import api from "PFCore/api";
import { Id } from "PFTypes";

export const requestHelp = (id: Id) =>
  api({
    url: `activities/${id}/request_help`,
    method: "POST"
  });
